import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {
  goSafeSegmentDataSelectorFn,
  showSafetyHygieneSectionSelector,
} from '@stencil/hotels-details-reducer/src/selectors';
import * as S from './SafetyAndHygiene.styles';
import {
  detailsNavigationIds,
  navigationMenuNames,
} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

const SafetyAndHygiene = () => {
  const {
    premiumPropData = {},
    persuasionTitle = '',
    title = '',
    premiumPropStatus,
    titleBackgroundColor = '',
    titleColor = '',
  } = useSelector(goSafeSegmentDataSelectorFn);
  const [open, setOpen] = useState(false);
  const showSafetyHygiene = useSelector(showSafetyHygieneSectionSelector);

  if (showSafetyHygiene) {
    const {heading = '', p_data = [], sub_heading: subHeading = ''} = premiumPropData;
    let finalTitle = premiumPropStatus ? title || persuasionTitle : persuasionTitle || title;
    return (
      <S.SafetyAndHygieneContainerWrap id={detailsNavigationIds.safetyHygiene}>
        <S.SafetyAndHygieneHeader backgroundColor={titleBackgroundColor}>
          <S.SafetyAndHygieneHeaderText
            color={titleColor}
            dangerouslySetInnerHTML={{
              __html: finalTitle || navigationMenuNames.safetyHygiene,
            }}
          />
        </S.SafetyAndHygieneHeader>
        <S.SafetyAndHygieneHotelHeading>{heading}</S.SafetyAndHygieneHotelHeading>
        <S.SafetyAndHygieneHotelSubHeading>
          {subHeading} {!open && <S.ViewAllLink onClick={() => setOpen(true)}>+more</S.ViewAllLink>}
        </S.SafetyAndHygieneHotelSubHeading>
        {open && (
          <S.SafetyAndHygieneList>
            {p_data.map(item => (
              <li>{item}</li>
            ))}
          </S.SafetyAndHygieneList>
        )}
      </S.SafetyAndHygieneContainerWrap>
    );
  }
  return null;
};

export default SafetyAndHygiene;
